import React, { useCallback } from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import fr from 'facet-rest';
import { navigateToPageInNewTab } from 'Views/Page/Content/Templates';

const PreviewScenarioKabobItem = () => {
  const { pageContentResource } = usePageContentContext();

  const handlePreviewPlanPageClick = useCallback(async (rel) => {
    navigateToPageInNewTab(
      rel.link('related').url(),
      true,
    );
  }, [pageContentResource]);

  return pageContentResource?.withRelationship(fr.relationships.planPage.name, (rel) => {
    return (
      <KabobMenuItem
        label={rel.meta('prompt')}
        test={'facet-plan-summary-kabob-item-preview-plan-page'}
        onClick={() => handlePreviewPlanPageClick(rel)}
      />
    );
  }, () => null);
};

PreviewScenarioKabobItem.defaultProps = {};

PreviewScenarioKabobItem.propTypes = {};

export default PreviewScenarioKabobItem;
